var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileOg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1077114",
    clipPath: "url(#clip0_460_17631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8582 10.1341C11.1817 10.1341 12.3278 9.65936 13.2643 8.72278C14.2007 7.78635 14.6754 6.64057 14.6754 5.31688C14.6754 3.99364 14.2007 2.84771 13.2641 1.91097C12.3275 0.974699 11.1816 0.5 9.8582 0.5C8.5345 0.5 7.38872 0.974699 6.4523 1.91113C5.51587 2.84756 5.04102 3.99349 5.04102 5.31688C5.04102 6.64057 5.51587 7.7865 6.45245 8.72293C7.38903 9.6592 8.53496 10.1341 9.8582 10.1341Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8582 10.1341C11.1817 10.1341 12.3278 9.65936 13.2643 8.72278C14.2007 7.78635 14.6754 6.64057 14.6754 5.31688C14.6754 3.99364 14.2007 2.84771 13.2641 1.91097C12.3275 0.974699 11.1816 0.5 9.8582 0.5C8.5345 0.5 7.38872 0.974699 6.4523 1.91113C5.51587 2.84756 5.04102 3.99349 5.04102 5.31688C5.04102 6.64057 5.51587 7.7865 6.45245 8.72293C7.38903 9.6592 8.53496 10.1341 9.8582 10.1341Z",
    fill: "url(#paint0_linear_460_17631)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2862 15.879C18.2592 15.4893 18.2046 15.0642 18.1242 14.6152C18.043 14.163 17.9385 13.7354 17.8134 13.3447C17.6841 12.9408 17.5083 12.5419 17.291 12.1597C17.0655 11.7629 16.8006 11.4175 16.5034 11.1332C16.1926 10.8358 15.812 10.5967 15.372 10.4223C14.9334 10.2488 14.4474 10.1609 13.9276 10.1609C13.7234 10.1609 13.526 10.2447 13.1446 10.4929C12.91 10.646 12.6355 10.823 12.3291 11.0188C12.0671 11.1857 11.7121 11.3421 11.2738 11.4837C10.8461 11.6221 10.4118 11.6923 9.98318 11.6923C9.55456 11.6923 9.12045 11.6221 8.69229 11.4837C8.25437 11.3422 7.89945 11.1858 7.63776 11.0189C7.33427 10.825 7.05961 10.648 6.82142 10.4928C6.44056 10.2445 6.24296 10.1608 6.0388 10.1608C5.51878 10.1608 5.03295 10.2488 4.59456 10.4225C4.15481 10.5966 3.7741 10.8357 3.46297 11.1334C3.16589 11.4178 2.90084 11.7631 2.67562 12.1597C2.45849 12.5419 2.28271 12.9406 2.15332 13.3448C2.02835 13.7356 1.92383 14.163 1.84265 14.6152C1.76224 15.0635 1.70761 15.4888 1.6806 15.8794C1.65405 16.2621 1.64062 16.6593 1.64062 17.0605C1.64062 18.1045 1.9725 18.9496 2.62695 19.573C3.27331 20.188 4.12856 20.5001 5.1686 20.5001H14.7987C15.8387 20.5001 16.6937 20.1882 17.3402 19.573C17.9948 18.9501 18.3267 18.1048 18.3267 17.0603C18.3265 16.6573 18.3129 16.2598 18.2862 15.879Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2862 15.879C18.2592 15.4893 18.2046 15.0642 18.1242 14.6152C18.043 14.163 17.9385 13.7354 17.8134 13.3447C17.6841 12.9408 17.5083 12.5419 17.291 12.1597C17.0655 11.7629 16.8006 11.4175 16.5034 11.1332C16.1926 10.8358 15.812 10.5967 15.372 10.4223C14.9334 10.2488 14.4474 10.1609 13.9276 10.1609C13.7234 10.1609 13.526 10.2447 13.1446 10.4929C12.91 10.646 12.6355 10.823 12.3291 11.0188C12.0671 11.1857 11.7121 11.3421 11.2738 11.4837C10.8461 11.6221 10.4118 11.6923 9.98318 11.6923C9.55456 11.6923 9.12045 11.6221 8.69229 11.4837C8.25437 11.3422 7.89945 11.1858 7.63776 11.0189C7.33427 10.825 7.05961 10.648 6.82142 10.4928C6.44056 10.2445 6.24296 10.1608 6.0388 10.1608C5.51878 10.1608 5.03295 10.2488 4.59456 10.4225C4.15481 10.5966 3.7741 10.8357 3.46297 11.1334C3.16589 11.4178 2.90084 11.7631 2.67562 12.1597C2.45849 12.5419 2.28271 12.9406 2.15332 13.3448C2.02835 13.7356 1.92383 14.163 1.84265 14.6152C1.76224 15.0635 1.70761 15.4888 1.6806 15.8794C1.65405 16.2621 1.64062 16.6593 1.64062 17.0605C1.64062 18.1045 1.9725 18.9496 2.62695 19.573C3.27331 20.188 4.12856 20.5001 5.1686 20.5001H14.7987C15.8387 20.5001 16.6937 20.1882 17.3402 19.573C17.9948 18.9501 18.3267 18.1048 18.3267 17.0603C18.3265 16.6573 18.3129 16.2598 18.2862 15.879Z",
    fill: "url(#paint1_linear_460_17631)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_17631",
    x1: 14.378,
    y1: 17.0817,
    x2: 2.79285,
    y2: 15.8078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_460_17631",
    x1: 17.8117,
    y1: 27.9563,
    x2: -1.87573,
    y2: 24.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_17631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9999,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOg);
export default __webpack_public_path__ + "static/media/profile_og.d935ad36ccb44c0dad60bb0097abcf2a.svg";
export { ForwardRef as ReactComponent };